import 'construct-style-sheets-polyfill';

import { BaseQLClient } from '@adornis/baseql/client/baseqlClient.js';
import { updateDynamicMetadata } from '@adornis/baseql/client/introspection.js';
import { updateDynamicValidators } from '@adornis/cms/db/dynamic-validators.js';
import { ChancenDynamicClassFormOfFinanzing } from '@chancenwerk/_cms/financing/entities/ChancenDynamicClassFormOfFinanzing.js';
import { ChancenDynamicClassProduct } from '@chancenwerk/_cms/products/entities/ChancenDynamicClassProduct.js';
import '@chancenwerk/db/index.js';
import '@chancenwerk/design/components/fonts.js';

BaseQLClient.initDefault();

// Update the dynmic schema for cms
void updateDynamicMetadata().then(() => {
  void updateDynamicValidators([ChancenDynamicClassProduct._class, ChancenDynamicClassFormOfFinanzing._class]);
});
